import React from 'react';
import PropTypes from 'prop-types';

import './SubmitLeadRequestError.css';

import WithPopup from 'src/HOC/WithPopup/WithPopup';
import { isMobileView } from 'src/Utility/utility';

const SubmitLeadRequestError = props => {
	const contentStyleDesktop = {
		position: 'absolute',
		margin: 'auto',
		top: '50%',
		transform: 'translateY(-50%)',
		width: '100%'
	}

	const contentStyleMobile = {
		position: 'absolute',
		margin: 'auto',
		top: '0%',
		width: '100%'
	}
	return (
		<WithPopup contentStyle={isMobileView() ? contentStyleMobile : contentStyleDesktop} >
			<div className="submit-lead-request-error__container alert-page error-page">
				<button
					onClick={props.close}
					className="submit-lead-request-error__close-btn"
					automationid={`SalesLead_Button_${props.automationidattr}CloseIcon_0`}
				>
					x
        </button>
				<div className="section-icon success-icon">
					<svg focusable="false" aria-hidden="true" className="icon">
						<use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-exclamation"></use>
					</svg>
				</div>
				<div className="submit-lead-request-error__heading">Oops...</div>
				<div
					className="submit-lead-request-error__description"
					automationid={`SalesLead_Div_${props.automationidattr}SubmitLeadError_0`}
				>
					Your request has not been submitted due to technical error. Please re-submit
				</div>
				<div className="submit-lead-request-error__btn">
					<button
						onClick={props.reSubmit}
						automationid={`SalesLead_Button_${props.automationidattr}ResubmitBtn_0`}
					>
						RE-SUBMIT
					</button>
				</div>
			</div>
		</WithPopup>
	)
}

SubmitLeadRequestError.propTypes = {
	close: PropTypes.func.isRequired,
	automationidattr: PropTypes.string,
	reSubmit: PropTypes.func.isRequired,
};

export default SubmitLeadRequestError;
